import React, { useState, useEffect } from 'react'
import "../Styles/Footer.css"
import { Container, Form, Row, Col } from "react-bootstrap";
import { Subscribe } from "./subscribe";
import Modal from "react-bootstrap/Modal";
import LazyLoad from "react-lazyload";
import laptopImg from "../Images/enterpriselaptop.png";
import talkdev from "../Images/TalkDev.png";
import talkmar from "../Images/TalkMartech.png";
import talkfin from "../Images/TalkFintech.png";
import talkit from "../Images/ITSecuritywire.png";
import talkcmo1 from "../Images/talkcmo1.png";
import abcGov from "../Images/abcGov.webp";
import facebook1 from "../Images/icons/facebook-icon.png";
import instagram1 from "../Images/icons/instagram-icon.png";
import linkedin1 from "../Images/icons/linkedin-icon.png";
import twitter1 from "../Images/icons/twitter-icon.png";
import youtube from "../Images/icons/Youtube_Logo.png";
import news6 from "../Images/news6.png";
// import { Link } from 'react-router-dom';
import { API_ROOT } from "../apiConfig";
import EnterpriseLogo from "../Images/enterpriseLogo.webp";
import facebook from "../Images/facebook-f.webp";
import instagram from "../Images/instagram.webp";
import linkedin from "../Images/linkedin.webp";
import twitter from "../Images/whiteTwitter.webp";

const Footer = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [policyText, setPolicyText] = useState(
    "*By clicking on the Submit button, you are agreeing with the Privacy Policy with Enterprise Talks.",
  );

  const validateEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(email);
    setIsValidEmail(isValid);
    return isValid;
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const resetForm = () => {
    setEmail("");
    setIsValidEmail(true);
    setPolicyText(
      "*By clicking on the Submit button, you are agreeing with the Privacy Policy with Enterprise Talks.",
    );
  };

  const handleSubmit = async () => {
    if (validateEmail()) {
      try {
        const response = await fetch(`${API_ROOT}/api/subscribe/add`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        });

        if (response.ok) {
          // The request was successful, you can handle the response here
          console.log("Subscription successful");
          resetForm(); // Reset the form after successful submission
          setPolicyText("Thank you for subscribing ✅");

          // Reset the complete form after 5 seconds
          setTimeout(() => {
            resetForm();
          }, 5000);
        } else {
          // The request failed, handle the error
          console.error("Subscription failed");

          // Check if the user already exists (assuming a specific response status code)
          // setTimeout(() => {
          //   resetForm();
          // }, 5000);
          if (response.status === 404) {
            // User already exists, show a message
            setPolicyText("This email is already subscribed ❌");
          }
        }
      } catch (error) {
        console.error("Error sending subscription request:", error);
      }
    } else {
      console.log("Invalid email");
    }
  };

  const [className5, setClassName5] = useState("");

  useEffect(() => {
    const sections = 5;
    let currentSection = 1;

    const setSectionClassName = () => {
      const removeTimer = setTimeout(() => {
        setClassName5("");
      }, 0);

      const setTimer = setTimeout(() => {
        setClassName5("loaded5");
        currentSection++;

        if (currentSection <= sections) {
          setSectionClassName();
        } else {
          // Remove scroll event listener if currentSection * 290 is reached
          window.removeEventListener("scroll", handleScroll);
        }
      }, currentSection * 10);

      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };

    const handleScroll = () => {
      // Add your logic here to determine when to trigger the code based on scroll
      if (window.scrollY > 160) {
        // Example condition: execute code when scrolled more than 100 pixels
        setSectionClassName();
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      {/* <LazyLoad className={className5}> */}
      <div
        className="footerPadding"
        style={{ backgroundColor: "rgb(238, 237, 237)" }}
      >
        <div className="container container-max">
          <div className="row">
            <div className="col-md-3">
              <div>
                <img
                  className="FootLogo"
                  src={EnterpriseLogo}
                  alt="Enterprise Logo"
                  width="640"
                  height="360"
                />
              </div>
              <div className="mt-4">
                <p className="just-text">By the CXO, For the CXO</p>
              </div>
              <div className="mt-2">
                <p className="just-text">
                  Expert inputs on challenges, triumphs and innovative solution
                  from corporate Movers and Shakers in the global Leadership
                  space to add value to Business decision making.
                </p>
              </div>
              <div className="mt-3">
                <div>
                  <a
                    className="text-black fw-bold hoverHead"
                    href="mailto: media@enterprisetalk.com"
                  >
                    Media@Enterprisetalk.com
                  </a>
                </div>
                <div className="mt-1">
                  <a
                    className="text-black fw-bold hoverHead"
                    href="mailto: sales@enterprisetalk.com"
                  >
                    Sales@EnterpriseTalk.com
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="">
                <div className="border-bottom mt-3">
                  <h6 className="fw-bold h5">About</h6>
                </div>
                <div className="border-bottom mt-3">
                  <p>
                    <a href="/about" className="text-black hoverHead">
                      About Us
                    </a>
                  </p>
                </div>
                <div className="border-bottom mt-3">
                  <a href="/contact-us">
                    <p className="hoverHead">Contact Us</p>
                  </a>
                </div>
                <div className="border-bottom mt-3">
                  <p className="hoverHead">
                    <p
                      className="text-black hoverHead"
                      style={{ cursor: "pointer" }}
                    // onClick={handleShow}
                    >
                      <a
                        href="/sublanding"  // The page you want to open
                        target="_blank"    // Opens in new tab
                        rel="noopener noreferrer" // Security best practice
                        className="text-black hoverHead"
                        style={{ cursor: "pointer", textDecoration: "none", display: "inline-block" }}
                      >
                        Subscribe
                      </a>
                      {/* Subscribe */}
                    </p>
                  </p>
                </div>
                <div className="border-bottom mt-3">
                  <a href="/sitemap">
                    <p className="hoverHead">Sitemap</p>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="">
                <div className="border-bottom mt-3">
                  <h6 className="fw-bold h5">Policies</h6>
                </div>
                <div className="border-bottom mt-3">
                  <a href="/privacy-policy">
                    {" "}
                    <p className="hoverHead">Privacy Policy</p>
                  </a>
                </div>

                <div className="border-bottom mt-3">
                  <a href="/opt-out-form">
                    {" "}
                    <p className="hoverHead">Do Not Sell My Information</p>{" "}
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-3 mt-3 followPadding">
              <div>
                <h6 className="fw-bold h5 ">Follow Us</h6>
                {/* <p className="fw-bold " style={{fontSize:"19px"}}>Follow Us</p> */}
              </div>
              <div className="d-flex mt-2">
                <div className="socialWrapper">
                  <div className="socialCard">
                    <a
                      href="https://www.facebook.com/enterprisetalk/"
                      target="_blank"
                    >
                      <source srcSet={facebook1} type="image/webp" />
                      <img
                        className="socialIcon"
                        src={facebook1}
                        alt="facebook"
                        defer
                      />
                    </a>
                  </div>
                  <div className="socialCard">
                    <a
                      href="https://www.instagram.com/enterprisetalk/"
                      target="_blank"
                    >
                      <source srcSet={instagram1} type="image/webp" />
                      <img
                        className="socialIcon"
                        src={instagram1}
                        alt="instagram"
                        loading="lazy"
                      />
                    </a>
                  </div>
                  <div className="socialCard">
                    <a href="https://x.com/enterprise_talk" target="_blank">
                      <source srcSet={twitter1} type="image/webp" />
                      <img
                        className="socialIcon"
                        src={twitter1}
                        alt="twitter img"
                        loading="lazy"
                      />
                    </a>
                  </div>
                  <div className="socialCard">
                    <a
                      href="https://www.linkedin.com/company/enterprisetalk"
                      target="_blank"
                    >
                      <source
                        srcSet={linkedin1}
                        type="image/webp"
                        target="_blank"
                      />
                      <img
                        className="socialIcon"
                        src={linkedin1}
                        alt="linkedin"
                        loading="lazy"
                      />
                    </a>
                  </div>
                  {/* Krishna */}
                  <div className="socialCard">
                    <a
                      href="https://www.youtube.com/@enterprisetalk"
                      target="_blank"
                    >
                      <source srcSet={youtube} type="image/webp" />
                      <img
                        className="socialIcon"
                        src={youtube}
                        alt="youtube"
                        loading="lazy"
                        style={{ marginTop: "5px" }}
                      />
                    </a>
                  </div>

                  {/* Krishna */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 mt-3">
            <h6 className="text-center h5 fw-bold">Our Publications</h6>
          </div>
          <div className="d-flex text-center otherPublic">
            <div>
              <a href="https://itsecuritywire.com/" target="_blank">
                {" "}
                <img
                  className="imgPublica"
                  src={`${talkit}?width=100`}
                  alt="talkit"
                  width="640"
                  height="360"
                  defer
                />
              </a>
            </div>
            <div>
              <a href="https://talkmartech.com/" target="_blank">
                {" "}
                <img
                  className="imgPublica"
                  src={`${talkmar}?width=100`}
                  alt="talkmar"
                  width="640"
                  height="360"
                  defer
                />{" "}
              </a>
            </div>
            <div>
              <a href="https://talkfintech.com/" target="_blank">
                {" "}
                <img
                  className="imgPublica"
                  src={`${talkfin}?width=100`}
                  alt="talkfin"
                  width="640"
                  height="360"
                  defer
                />{" "}
              </a>
            </div>
            <div>
              <a href="https://talkcmo.com/" target="_blank">
                {" "}
                <img
                  className="imgPublicaCMO"
                  src={`${talkcmo1}?width=100`}
                  alt="talkcmo"
                  width="640"
                  height="360"
                  defer
                />{" "}
              </a>
            </div>
            <div>
              <a href="https://talkdev.com/" target="_blank">
                {" "}
                <img
                  className="imgPublica"
                  src={`${talkdev}?width=100`}
                  alt="talkdev"
                  width="640"
                  height="360"
                  defer
                />{" "}
              </a>
            </div>

            <div>
              <a href="https://talkgovtech.com/" target="_blank">
                {" "}
                <img
                  className="imgPublica"
                  src={`${abcGov}?width=100`}
                  style={{ width: "108px", height: "41px" }}
                  alt="talkGov"
                  width="640"
                  height="360"
                  defer
                />{" "}
              </a>
            </div>
          </div>
          <div className="mt-4" style={{ borderTop: "1px solid #bdbdbd" }}>
            <p className="mt-2 mb-2" style={{ fontSize: " 12px" }}>
              An Imprint of OnDot ® Media © | All Rights Reserved |{" "}
              <a href="/privacy-policy" className="colorRed hoverHead">
                Privacy Policy
              </a>
            </p>
          </div>
        </div>
      </div>
      <Subscribe show={show} handleClose={handleClose} />
    </div>
  );
};

export default Footer